import { __assign } from "tslib";
import { useEffect } from 'react';
import { useContext, useState } from 'react';
import { PrefetchContext } from './prefetch-context';
var defaultState = {
    data: undefined,
    ready: false,
    error: undefined,
};
export var usePrefetch = function () {
    var _a = useState(defaultState), currState = _a[0], setCurrState = _a[1];
    var promise = useContext(PrefetchContext);
    useEffect(function () {
        currState.ready = false;
        promise === null || promise === void 0 ? void 0 : promise.then(function (res) {
            setCurrState(__assign(__assign({}, currState), { error: undefined, data: res, ready: true }));
        }).catch(function (e) {
            setCurrState(__assign(__assign({}, currState), { ready: true, data: undefined, error: e }));
        });
    }, [promise]);
    return currState;
};
//# sourceMappingURL=use-prefetch.js.map